import { format } from '@/services/datetime'

export default (value) => {
  return format.toMDTG(value)
}
